import React from 'react';
import { Card } from 'antd';

export default function TableToolbar({ children, style }) {
  return (
    <Card className="table-toolbar" size="small" style={{ marginBottom: 16, ...style }}>
      {children}
    </Card>
  );
}
